// extracted by mini-css-extract-plugin
export var close = "HubNotification-module__close___P6YYO";
export var content = "HubNotification-module__content___oHv1w";
export var error = "HubNotification-module__error___6qAA4";
export var leaving = "HubNotification-module__leaving___UNn1w";
export var notification = "HubNotification-module__notification___Tr3OF";
export var notificationEnter = "HubNotification-module__notificationEnter___xr+Kj";
export var notificationLeave = "HubNotification-module__notificationLeave___mugaL";
export var notificationRegion = "HubNotification-module__notificationRegion___3o2mG";
export var statusIcon = "HubNotification-module__statusIcon___aeO-G";
export var success = "HubNotification-module__success___CdW+j";